import { combineReducers } from 'redux';
import formReducer from './form';
import importerReducer from './importer';
import mappingReducer from './mapping';
import verificationReducer from './verification';
import runRecordsReducer from './run_records';
import recordTableUIReducer from './record_table_ui';
import stepperReducer from './stepper';

const nullReducer = state => ({ ...state });

export default combineReducers({
  form: formReducer,
  importer: importerReducer,
  mapping: mappingReducer,
  paths: nullReducer,
  runRecords: runRecordsReducer,
  recordTableUI: recordTableUIReducer,
  static: nullReducer,
  stepper: stepperReducer,
  verification: verificationReducer
});
